import { useNavigate } from 'react-router-dom';
import AdminSidebar from '@/components/AdminSidebar';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { Menu, FileText, Sparkles, ArrowRight } from 'lucide-react';
import { pageConfigs } from '@/config/pageConfigs';
import { useQuery } from 'react-query';
import { getExpertises } from '@/api/expertiseService';

export default function CmsDashboard() {
  const navigate = useNavigate();
  const { data: expertises = [] } = useQuery('expertises', getExpertises);

  return (
    <SidebarProvider>
      <div className="min-h-screen flex w-full">
        <AdminSidebar />
        <main className="flex-1 overflow-auto bg-[#f6f6f7]">
          <div className="border-b border-gray-200 bg-white px-8 py-6">
            <div className="max-w-5xl mx-auto flex items-center gap-3">
              <SidebarTrigger className="md:hidden"><Menu className="h-5 w-5" /></SidebarTrigger>
              <div>
                <h1 className="text-xl font-semibold text-[#202223]">Pagina's</h1>
                <p className="text-sm text-[#6d7175] mt-0.5">Bewerk de inhoud van je website pagina's</p>
              </div>
            </div>
          </div>

          <div className="px-8 py-8">
            <div className="max-w-5xl mx-auto space-y-8">
              {/* Website pagina's */}
              <div>
                <h2 className="text-[13px] font-semibold text-[#6d7175] uppercase tracking-wide mb-3">Website pagina's</h2>
                <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.04)] border border-gray-200/60 divide-y divide-gray-100">
                  {pageConfigs.map((page) => {
                    const totalFields = page.sections.reduce((sum, s) => sum + s.fields.length, 0);
                    return (
                      <button
                        key={page.slug}
                        onClick={() => navigate(`/admin/cms/${page.slug}`)}
                        className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50/80 transition-colors text-left group"
                      >
                        <div className="p-2 rounded-lg bg-gray-100 text-gray-500 group-hover:bg-indigo-50 group-hover:text-indigo-600 transition-colors shrink-0">
                          <FileText className="h-4 w-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-[#202223]">{page.name}</p>
                          <p className="text-[13px] text-[#6d7175] truncate">{page.description}</p>
                        </div>
                        <div className="flex items-center gap-4 shrink-0">
                          <span className="text-xs text-[#6d7175] hidden sm:block">{page.sections.length} secties &middot; {totalFields} velden</span>
                          <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-gray-400 transition-colors" />
                        </div>
                      </button>
                    );
                  })}
                </div>
              </div>

              {/* Expertise detail pagina's */}
              {expertises.length > 0 && (
                <div>
                  <h2 className="text-[13px] font-semibold text-[#6d7175] uppercase tracking-wide mb-3">Expertise pagina's</h2>
                  <div className="bg-white rounded-xl shadow-[0_1px_3px_rgba(0,0,0,0.04)] border border-gray-200/60 divide-y divide-gray-100">
                    {expertises.map((exp) => (
                      <button
                        key={exp.id}
                        onClick={() => navigate(`/admin/cms/expertise-${exp.id}`)}
                        className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50/80 transition-colors text-left group"
                      >
                        <div className="p-2 rounded-lg bg-amber-50 text-amber-600 shrink-0">
                          <Sparkles className="h-4 w-4" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <p className="text-sm font-medium text-[#202223]">{exp.title}</p>
                          <p className="text-[13px] text-[#6d7175] truncate">Expertise detail pagina</p>
                        </div>
                        <ArrowRight className="h-4 w-4 text-gray-300 group-hover:text-gray-400 transition-colors shrink-0" />
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </main>
      </div>
    </SidebarProvider>
  );
}
